import { Flex } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { useRef } from "react";
import { showConfirm } from "infra/helpers/alerta";
import { Col, Row } from "antd";
import CardDefault from "ui/components/Cards/CardDefault";

function ControleImportacao({
  data,
  handleProccess,
  setData,
}: {
  data: any[];
  handleProccess: any;
  setData: any;
}) {
  const inputRef = useRef<any>(null);

  return (
    <Row>
      <Col sm={10}>
        <CardDefault>
          <Flex>
            <Flex flex={1}>
              <input
                type="file"
                ref={inputRef}
                onChange={async (ev) => {
                  if (ev.target.files?.length) {
                    const [file] = ev.target.files;
                    if (data.length) {
                      showConfirm(
                        "Deseja substituir os dados da planilha?"
                      ).then(async ({ isConfirmed }) => {
                        if (isConfirmed) {
                          handleProccess(file);
                        }
                      });
                    } else {
                      handleProccess(file);
                    }

                    inputRef.current.value = "";
                  }
                }}
              />
            </Flex>
            <Flex>
              <Button
                size="sm"
                onClick={() => {
                  setData([]);
                }}
              >
                Limpar
              </Button>
            </Flex>
          </Flex>
        </CardDefault>
      </Col>
    </Row>
  );
}

export default ControleImportacao;
